<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5 4.17422L5 11.8258C5 12.6801 6.00212 13.141 6.65079 12.585L11.1142 8.75926C11.5798 8.36016 11.5798 7.63984 11.1142 7.24074L6.65079 3.41496C6.00212 2.85896 5 3.31987 5 4.17422Z"
      fill="currentColor"
    />
  </svg>
</template>
